module.exports = __webpack_public_path__ + "static/media/home-stock-01.4950f58c.png";